import * as actionTypes from './actionTypes';
import { Portfolio } from 'api';
// import { INSERT_PORTFOLIO_TO_STORE } from './actionTypes';

export interface IPortfolioStore {
    portfolios: Portfolio[],
    portfolio?: Portfolio,
    config?: any,
    isLoading: boolean,
    isLoaded: boolean,
    saving: boolean,
    errorMsg?: string
}

export interface IAction {
    type: string, 
    payload:any
}

const initialState:IPortfolioStore = {
    portfolios: [/* portfolio */],
    portfolio: undefined,
    config: {
        validFor: [/*{id, name}*/],
        tariffs: {
            packages: [/*{id, name}*/],
            type: [/*{id, name}*/],
            level: [/*{id, name}*/],
        },
        options: [/*{id, name, values[]}*/],
    },
    isLoading: false,
    isLoaded: false,
    saving: false,
    errorMsg: ""
}

const portfolio = (state: IPortfolioStore = initialState, action: IAction) => {
    switch (action.type) {
        
        case actionTypes.SET_ACTIVE_PORTFOLIO:
            state = {
                ...state,
                portfolio: action.payload
            }
            break;
        
        case actionTypes.GET_PORTFOLIOS:
        case actionTypes.SAVE_PORTFOLIO:
        case actionTypes.COPY_PORTFOLIO:
            state = {
                ...state,
                isLoading: true
            }
            break;
        
        case actionTypes.GET_PORTFOLIOS_SUCCESS:
            state = {
                ...state,
                portfolios: [...action.payload],
                isLoading: false,
                isLoaded: true
            }
            break;
        
        case actionTypes.GET_PORTFOLIO:
            state = {
                ...state,
                isLoading: true
            }
            break;
         
        case actionTypes.GET_PORTFOLIO_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                portfolio: action.payload
            }
            break;

        case actionTypes.GET_PORTFOLIO_CONFIG:
            state = {
                ...state,
                isLoading: true
            }
            break;

        case actionTypes.GET_PORTFOLIO_CONFIG_SUCCESS:
            state = {
                ...state,
                config: { ...action.payload },
                isLoading: false
            }
            break;

        case actionTypes.SAVE_PORTFOLIO_SUCCESS:
            state = {
                ...state,
                portfolios: [action.payload, ...state.portfolios],
                portfolio: { ...action.payload },
                isLoading: false
            }
            break;
            
        case actionTypes.UPDATE_PORTFOLIO_LIST:
            state = {
                ...state,
                portfolios: [...action.payload],
                isLoading: false
            }
            break;

        case actionTypes.INSERT_PORTFOLIO_TO_STORE:
            state = {
                ...state,
                portfolios: [action.payload, ...state.portfolios],
                isLoading: false
            }
            break;

        case actionTypes.DISCARD_ACTIVE_PORTFOLIO:
            state = {
                ...state,
                portfolio: undefined
            }
            break;
            

        case actionTypes.PORTFOLIO_API_ERROR:
            state = {
                ...state,
                errorMsg: action.payload
            }
            break;
        

        case actionTypes.PORTFOLIO_API_ERROR_CLEAR:
            state = {
                ...state,
                errorMsg: ""
            }
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default portfolio;